import * as React from "react";
import { SVGProps } from "react";
const SvgMeterReadNoRead = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#meter-read-no-read_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M30 23a1 1 0 0 1-1 1H17V8h12a1 1 0 0 1 1 1v14ZM3 24a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h12v16H3ZM3 6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h26a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3H3Zm3 9a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2H6Zm15 0a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2h-5Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="meter-read-no-read_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMeterReadNoRead;
